"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("@styles/overrides/quill_override.scss");
var quillToText_1 = require("@utils/quillToText");
var LocationImage_1 = __importDefault(require("@components/Images/LocationImage"));
var overviewStyles = __importStar(require("./OverviewLocations.module.scss"));
function OverviewMechanicsElement(_a) {
    var location = _a.location, characters = _a.characters, t = _a.t;
    var locationCharacters = characters.filter(function (character) {
        return location.characters.find(function (id) { return id === character.id; });
    });
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("section", { className: overviewStyles.sub_header, children: [(0, jsx_runtime_1.jsx)("h2", { children: location.name }), location.img ? ((0, jsx_runtime_1.jsx)(LocationImage_1.default, { path: location.img ? location.img : "", alt: "main image", width: "700px" })) : null] }), (0, jsx_runtime_1.jsxs)("section", { className: overviewStyles.paragraphs_container, children: [(0, jsx_runtime_1.jsxs)("div", { className: overviewStyles.paragraph_element, children: [(0, jsx_runtime_1.jsxs)("header", { className: overviewStyles.paragraph_header, children: [t.environment, ":", " "] }), location.environment] }), (0, jsx_runtime_1.jsxs)("div", { className: overviewStyles.paragraph_element, children: [(0, jsx_runtime_1.jsxs)("header", { className: overviewStyles.paragraph_header, children: [t.description, ":", " "] }), (0, jsx_runtime_1.jsx)("div", { className: overviewStyles.formatted_text, children: (0, quillToText_1.formatQuillOutput)(location.description) })] }), (0, jsx_runtime_1.jsxs)("div", { className: overviewStyles.paragraph_element, children: [(0, jsx_runtime_1.jsxs)("header", { className: overviewStyles.paragraph_header, children: [t.characters, ":", " "] }), (0, jsx_runtime_1.jsx)("ul", { children: locationCharacters.length > 0 ? (locationCharacters.map(function (character) { return ((0, jsx_runtime_1.jsx)("li", { children: character === null || character === void 0 ? void 0 : character.name }, character === null || character === void 0 ? void 0 : character.id)); })) : ((0, jsx_runtime_1.jsx)("span", { children: "-" })) })] })] })] }));
}
exports.default = OverviewMechanicsElement;
